package one.healthium.insights.ui.components

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.SpanStyle
import com.mikepenz.markdown.model.DefaultMarkdownAnnotatorConfig
import com.mikepenz.markdown.model.MarkdownAnnotator
import com.mikepenz.markdown.model.MarkdownAnnotatorConfig
import org.intellij.markdown.ast.ASTNode

class HtmlSpanAnnotator : MarkdownAnnotator {

    private val regex = """<span\s+style=["']color:([^"']+)["']>""".toRegex()

    private var pushIndex = -1

    override val annotate: (AnnotatedString.Builder.(content: String, child: ASTNode) -> Boolean) = { content, child ->
        val substring = content.subSequence(child.startOffset, child.endOffset)
        if (child.type.name == "HTML_TAG") {
            if (substring.startsWith("<span")) {
                regex.find(substring)?.groupValues?.get(1)?.let { colorStr ->
                    parseColor(colorStr)?.let { color ->
                        pushIndex = pushStyle(SpanStyle(color = Color(color)))
                    }
                }
            } else if (substring.startsWith("</span") && pushIndex > -1) {
                pop(pushIndex)
            }
            true
        } else false
    }
    override val config: MarkdownAnnotatorConfig
        get() = DefaultMarkdownAnnotatorConfig()

    private fun parseColor(colorString: String): Long? {
        var colorLong = if (colorString[0] == '#') {
            // Use a long to avoid rollovers on #ffXXXXXX
            colorString.substring(1).toLongOrNull(16)
        } else {
            colorString.toLongOrNull(16)
        }
        if (colorLong != null) {
            if (colorString.length == 6 || colorString.length == 7) {
                // Set the alpha value
                colorLong = colorLong or 0x00000000ff000000L
            } else if (colorString.length != 9) {
                return null
            }
        }
        return colorLong
    }
}